import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useWaBlock } from "@/components/WaButton";
import { Star, Copy, Check } from "lucide-react";
import { toast } from "sonner";

// "Send feedback form" row — Copy & open WhatsApp (customer group) + "Sent?" logs [WhatsApp] Feedback form sent.
export function NpsTaskRow({ t, navigate, onDone, embedded = false }) {
  const wa = useWaBlock(t.record_id);
  const [busy, setBusy] = useState(false);
  const copyOpen = () => {
    navigator.clipboard?.writeText(t.message);
    toast.success("Message copied");
    if (wa?.customer_open_link) window.open(wa.customer_open_link, "_blank");
    else toast.info("No linked customer group — paste the message in WhatsApp");
  };
  const sent = async () => {
    setBusy(true);
    try { const r = await api.post(`/cases/${t.record_id}/nps/sent`); toast.success(`${r.data.label} · logged in Case History`); onDone && onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className={`flex flex-wrap items-center gap-2 text-xs rounded-lg px-3 py-2 border ${embedded ? "bg-[#F5B71D]/10 border-[#F5B71D]/40" : "bg-white border-[#E2E2E2]"}`} data-testid={`nps-task-${t.case_id}`}>
      <Star className="w-3.5 h-3.5 text-[#F5B71D]" />
      {!embedded && <span className="font-mono text-[#E2521B] font-semibold cursor-pointer" onClick={() => navigate(`/cases/${t.record_id}`)}>{t.case_id}</span>}
      <span className="text-[#333333]">{t.task === "remind" ? "Feedback reminder" : "Send feedback form"} · {t.borrower}{t.task === "remind" && <span className="text-[#6B7280]"> · no response 5 days after sending</span>}</span>
      <span className="ml-auto flex items-center gap-1.5">
        <button onClick={copyOpen} data-testid={`nps-copy-${t.case_id}`} className="px-2 py-0.5 rounded-full border border-[#E2E2E2] text-[#333333] hover:border-[#FF4802] flex items-center gap-1"><Copy className="w-3 h-3" /> Copy & open WhatsApp</button>
        <button onClick={sent} disabled={busy} data-testid={`nps-sent-${t.case_id}`} className="px-2 py-0.5 rounded-full bg-[#159A50] text-white flex items-center gap-1 disabled:opacity-50"><Check className="w-3 h-3" /> Sent?</button>
      </span>
    </div>
  );
}

// Case banner: visible when a form is due / sent but unanswered.
export function NpsBanner({ recordId }) {
  const [d, setD] = useState(null);
  const load = () => api.get(`/cases/${recordId}/nps`).then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, [recordId]); // eslint-disable-line
  if (!d || !d.show_banner) return null;
  if (!d.task) return <div className="rounded-2xl border border-[#F5B71D]/40 bg-[#F5B71D]/10 p-3 text-xs text-[#92600a]" data-testid="nps-banner">Feedback form sent {d.sent?.at?.slice(0, 10)} · waiting for the customer's response</div>;
  return <div data-testid="nps-banner"><NpsTaskRow t={d} onDone={load} embedded /></div>;
}
